import useScrollAnimation from '@/hooks/useScrollAnimation';
import title from '@/assets/title.png';

export default function ConceptSection() {
  const { ref, isVisible } = useScrollAnimation();

  return (
    <section id="concept" className="relative py-20 md:py-28 px-4 md:px-20 bg-background-50">
      <div
        ref={ref}
       className="max-w-5xl mx-auto grid grid-cols-[3fr_2fr]  ..."
      >
        {/* 左：タイトル画像 */}
        <div className="flex-shrink-0 w-full md:w-auto flex justify-center md:justify-start">
          <img
            src={title}
            alt="こだわり"
            className="w-48 md:w-56 lg:w-64 h-auto object-contain"
          />
        </div>
        {/* 右：テキスト（左寄せ） */}
        <div className="flex-1 text-left">
          <p className="text-primary-500 font-sans text-xs tracking-[0.4em] mb-4">
            CONCEPT
          </p>
          
        
          <p className="text-foreground-600 text-sm md:text-base leading-relaxed max-w-2xl mx-auto">
            北海道室蘭の街にひっそりと佇む、完全個室の隠れ家リラクゼーションエステ「湯の華」。<br />
            数あるサロンの中でも一線を画す当店の魅力は、極上のオイルトリートメントに加え、本格的な「タイ古式マッサージ」もご堪能いただけること。
            心から満たされる深い癒やしと、身体が軽くなる圧倒的な爽快感。日常の喧騒を忘れ、ワンランク上の極上リラクゼーションを心ゆくまでお楽しみください。
          </p>

        </div>
      </div>
    </section>
  );
}